import React, { useState } from "react";

import { ACCOUNT_ENUM } from "./Route";

import PortalSelect from "./PortalSelect";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";

export default function Account() {
  const [page, setPage] = useState(ACCOUNT_ENUM.ROLE_SELECT);
  const [loginAs, setLoginAs] = useState(null);

  switch (page) {
    case ACCOUNT_ENUM.ROLE_SELECT:
      return <PortalSelect setPage={setPage} setLoginAs={setLoginAs} />;
    case ACCOUNT_ENUM.LOGIN:
      return (
        <Login
          setPage={setPage}
          loginAs={loginAs}
          setLoginAs={setLoginAs}
        />
      );
    case ACCOUNT_ENUM.FORGOT_PASSWORD:
      return <ForgotPassword setPage={setPage} loginAs={loginAs} />;
    default:
      return <PortalSelect setPage={setPage} setLoginAs={setLoginAs} />;
  }
}
